import * as XLSX from "xlsx"

export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	methods: {
		downloadExcelFileWithJson(content: any, filename: any) {
			const data = XLSX.utils.json_to_sheet(content);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, data, 'data');
			XLSX.writeFile(workbook, filename);
		},
		downloadExcelFileWithArray(content: any, filename: any) {
			const worksheet = XLSX.utils.aoa_to_sheet(content);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, 'data');
			XLSX.writeFile(workbook, filename);
		},
		// getLetterByOne(current: string, increment = true): string {
		// 	const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
		// 	const result = current.split('');
		// 	let index = result.length - 1;

		// 	while (index >= 0) {
		// 		const char = result[index];
		// 		const charIndex = alphabet.indexOf(char);

		// 		if (increment) {
		// 			if (char === 'Z') {
		// 				result[index] = 'A';
		// 				if (index === 0) {
		// 					result.unshift('A');
		// 				}
		// 			} else {
		// 				result[index] = alphabet[charIndex + 1];
		// 				break;
		// 			}
		// 		} else {
		// 			if (char === 'A') {
		// 				result[index] = 'Z';
		// 				if (index === 0) {
		// 					result.shift();
		// 				}
		// 			} else {
		// 				result[index] = alphabet[charIndex - 1];
		// 				break;
		// 			}
		// 		}
		// 		index--;
		// 	}

		// 	return result.join('');
		// },
		// getLetterByCurrentStep(current: string, n: number): string | null {
		// 	if (!current || typeof n !== "number") {
		// 		return null;
		// 	}
		// 	let result = current;
		// 	const increment = n > 0;
		// 	const steps = Math.abs(n);
			
		// 	for (let i = 0; i < steps; i++) {
		// 		result = this.getLetterByOne(result, increment);
		// 		if (!result) {
		// 			return null;
		// 		}
		// 	}
			
		// 	return result;
		// },
		// getHeaderLetter(columnIndex: number): any {
		// 	return this.getLetterByCurrentStep(String.fromCharCode(64 + 1), columnIndex);
		// }
	}
};